import { ADD_FAVOURITES_VIEW, MY_FAVOURITES_VIEW } from ".";

// Events
export const BET_SHUFFLE = "Shuffle";
export const FILTERS = "Filters";
export const FAVOURITES = "Favourites";

// Event Types
export const BET_SHUFFLE_TYPE = "Shuffle";
export const FILTERS_TYPE = "Filters";
export const FAVOURITES_ANALYTICS_VIEW = "Favourites";
export const STATS_FILTER_TYPE = "Stats";
export const DATE_FILTER_TYPE = "Date";
export const FIXTURES_FILTER_TYPE = "Fixtures";
export const MARKETS_FILTER_TYPE = "Markets";
export const SORT_BY_FILTER_TYPE = "Sort By";

// Event Actions
export const OPEN = "Open";
export const CLOSE = "Close";
export const SELECT = "Select";
export const SELECT_ALL = "Select All";
export const DESELECT = "Deselect";
export const DESELECT_ALL = "Deselect All";
export const CLEAR = "Clear";
export const SHOW = "Show";
export const ALL = "All";
export const ADD = "Add";
export const VIEW = "View";
export const ADDTO = "AddTo";
export const CREATE = "Create";
export const DELETE = "Delete";
export const EDIT = "Edit";
export const EDITNAME = "EditName";
export const ADDBET = "addBet";
